export interface IRegionStatisticsQueryDto {
  city_id?: number | string;
  start_date?: string;
  end_date?: string;
}

export interface SubcityStatistic {
  subcityId: number;
  subcityName: string;
  cityId: number;
  cityName: string;
  packageCount: number;
  totalDesi: number;
  companyCount: number;
}

interface CityData {
  cityId: number;
  cityName: string;
  packageCount: number;
  totalDesi: number;
  companyCount: number;
}

export class IRegionStatisticsListResponse {
  regionId: number;
  regionName: string;
  companyId: number;
  startDate: string;
  endDate: string;
  totalPackages: number;
  cityName?: string;
  totalDesi: number;
  subcityStatistics: SubcityStatistic[];
  cityStatistics: CityData[];
}
